import { of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { consumeAPI2, consumePostAPI2 } from '../apiClient';
import { getSaveData, saveData, updateReadState } from './memoryData/seekerMessagesData';

//  It get data saved and if not found return previous data
const getSavedDataInMemory = (limit, offset, sort, isMobile) => d => {
  if (!d.error) {
    const founded = getSaveData(limit, offset, sort, isMobile);
    if (founded) {
      d.data = founded;
    } else {
      d.data = getSaveData(limit, offset - limit, sort, isMobile);
    }
  }
  return d;
};

const saveDataInMemory = (limit, offset, sort) => d => {
  if (!d.error) {
    saveData(limit, offset, sort, d.data);
  }
};

export async function getSeekerLeads(limit = 10, offset = 0, sort, isMobile) {
  const url = `/seeker/leads?limit=${limit}&offset=${offset}&sort=${sort}`;
  const data = getSaveData(limit, offset, sort, isMobile);

  if (data !== undefined) {
    return of({ error: false, data }).toPromise();
  }

  return consumeAPI2(url)
    .pipe(
      tap(saveDataInMemory(limit, offset, sort)),
      map(getSavedDataInMemory(limit, offset, sort, isMobile))
    )
    .toPromise();
}

export async function getSeekerInfo(id) {
  const url = `/seeker/leads/${id}`;
  return consumeAPI2(url)
    .pipe(
      map(d => {
        if (!d.error) {
          if (d.data.publisher) {
            d.data.publisher.logoUrl = d.data.publisher.url_logo;
          }
          if (d.data.posting) {
            d.data.posting.postingType = d.data.posting.posting_type;
          }
        }
        return d;
      })
    )
    .toPromise();
}

export async function getChatMessagesSeeker(id) {
  const url = `/seeker/leads/${id}/chat`;
  return consumeAPI2(url)
    .pipe(
      tap(d => {
        if (!d.error) {
          d.data = d.data
            .map(message => {
              message.from_seeker = !message.from_seeker;
              return message;
            })
            .filter(message => ['6', '10', undefined].includes(message.action_type));
        }
      })
    )
    .toPromise();
}

export async function fetchMarkAsRead(leadId) {
  const url = `/seeker/leads/${leadId}/read`;
  return consumePostAPI2(url)
    .pipe(
      tap(d => {
        if (!d.error) {
          updateReadState(leadId);
        }
      })
    )
    .toPromise();
}
